import { Paper, Box, Typography, Avatar } from "@mui/material";
import PersonIcon from '@mui/icons-material/Person';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import classes from './AuthorPopup.module.scss';
import { Author } from "../../interfaces/Author";

const AuthorInfoPopup = ({ author }: { author: Author }) => {
  return (
    <Box className={`position-absolute ${classes.authorPopupContainer}`}>
      <Paper className={`rounded overflow-hidden shadow ${classes.authorPopupContent}`} elevation={0}>
        <Box className={`d-flex flex-column p-3 ${classes.contentBox}`}>
          <Box className="d-flex align-items-center mb-3">
            {author.attributes?.metadata?.image ? (
              <Avatar
                src={author.attributes.metadata.image}
                alt={author.attributes?.name || "Unknown Author"}
                className={`me-2 ${classes?.authorImage}`}
              />
            ) : (
              <Avatar className={`me-2 ${classes?.personIcon}`}>
                <PersonIcon fontSize="small" />
              </Avatar>
            )}
            <Box>
              <Typography className="fw-bold mb-0">{author.attributes?.name || "Unknown Author"}</Typography>
              <Typography className="text-muted small">
                {author.attributes?.metadata?.username ? `@${author.attributes.metadata.username}` : "No username"}
              </Typography>
            </Box>
          </Box>

          <Box className="d-flex justify-content-between mb-2">
            <Typography>Total Picks:</Typography>
            <Typography className="fw-medium">
              {author.attributes?.metadata?.picksTotal !== undefined ? 
                author.attributes.metadata.picksTotal : 
                "N/A"}
            </Typography>
          </Box>

          <Box className="d-flex justify-content-between mb-2">
            <Box className="d-flex align-items-center">
              <CheckCircleIcon className={`text-success me-1 ${classes.statusIcon}`} />
              <Typography>Correct:</Typography>
            </Box>
            <Typography className="text-success fw-bold">
              {author.attributes?.metadata?.picksCorrect !== undefined ? 
                author.attributes.metadata.picksCorrect : 
                "N/A"}
            </Typography>
          </Box>

          <Box className="d-flex justify-content-between mb-2">
            <Box className="d-flex align-items-center">
              <CancelIcon className={`text-danger me-1 ${classes.statusIcon}`} />
              <Typography>Incorrect:</Typography>
            </Box>
            <Typography className="text-danger fw-bold">
              {author.attributes?.metadata?.picksIncorrect !== undefined ? 
                author.attributes.metadata.picksIncorrect : 
                "N/A"}
            </Typography>
          </Box>

          <Box className="mt-2 pt-2 border-top">
            <Box className="d-flex justify-content-between">
              <Typography>Win Percentage:</Typography>
              <Typography className="fw-bold">
                {author.attributes?.metadata?.winPercentage !== undefined ? 
                  `${author.attributes.metadata.winPercentage}%` : 
                  "N/A"}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default AuthorInfoPopup;
